module.exports = __webpack_public_path__ + "static/kom-816270a9521f47b69321f373e83bd15c.png";